module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_f_leucistic.f820f2a2.png";